// Generated by Melange

import * as Stdlib__List from "melange/list.js";
import * as Stdlib__Option from "melange/option.js";

function selectable(s) {
  const now = Date.now();
  if (s.verified && Stdlib__Option.fold(true, (function (expires) {
      return expires > now;
    }), s.expires_at)) {
    if (Stdlib__List.mem(s.status, {
        hd: "ready",
        tl: {
          hd: "exhausted",
          tl: /* [] */ 0
        }
      })) {
      return true;
    } else if (s.status === "cooling_down") {
      return Stdlib__Option.fold(false, (function (reset) {
        return reset <= now;
      }), s.quota_reset_at);
    } else {
      return false;
    }
  } else {
    return false;
  }
}

function label(s) {
  const match = s.provider;
  let service;
  switch (match) {
    case "chatgpt" :
      service = "ChatGPT";
      break;
    case "cursor" :
      service = "Cursor";
      break;
    case "devin" :
      service = "Devin";
      break;
    case "grok" :
      service = "Grok";
      break;
    default:
      service = s.provider;
  }
  return service + (" / " + (s.label + (" / " + (
    s.ownership === "personal" ? "Personal" : "Shared by " + s.owner_login
  ))));
}

export {
  selectable,
  label,
}
/* No side effect */
